let isFuseFiveEnabled = false;

export const initializeFuseFiveFeatureFlag = (value) => {
    isFuseFiveEnabled = value;
};

export const isFuse5Enabled = () => {
    return isFuseFiveEnabled;
};
